import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';


const DynamicBoxes = () => {
  const navigate = useNavigate();
  const [boxes] = useState([
    {
      id: 1,
      icon: 'assets/images/website-development-icon.svg',
      title: 'Website Development',
      description: 'First impressions are last impressions. Our websites truly portray who we are as a company. Let us help you in making your vision come true!',
      link: '/website-development',
    },
    {
      id: 2,
      icon: 'assets/images/mobile-dev-icon.svg',
      title: 'Mobile Application Development',
      description: 'There are various forms and scales of mobile app development. Altering your application for iOS and/or android won’t be a problem for us!',
      link: '/mobile-development',
    },
    {
      id: 3,
      icon: 'assets/images/badge.svg',
      title: 'Quality Assurance',
      description: "Want your product or service right the first time? So do we! Our skilled professionals follow every key step of the software development cycle to prevent potential defects.",
      link: '/quality-assurance',
    },
    {
      id: 4,
      icon: 'assets/images/customer-service.svg',
      title: 'Staffing Solutions',
      description: "We deliver skilled professionals for temporary, permanent, or contract roles—quickly and efficiently, aligned to your business needs.",
      link: '/staffing-solutions',
    },
    {
      id: 5,
      icon: 'assets/images/budget.svg',
      title: 'Business Branding',
      description: 'Let us help you in establishing your company’s entity! We create World-class logo design with best principles of visual hierarchy which will make your company stand out of the ordinary.',
      link: '/buisness-branding',
    },
    {
      id: 6,
      icon: 'assets/images/mail-box.svg',
      title: 'Graphic Designing',
      description: 'It’s a competitive world out there, and making an outstanding first impression is vital for getting across your objectives and establishing a long lasting relationship with potential clients.',
      link: '/graphic-designing',
    },
    {
      id: 7,
      icon: 'assets/images/tool-box.svg',
      title: 'Custom Web Solution',
      description: 'As an experienced and professional custom web design company, we have a wealth of experience in all elements of web design (including graphics, programming, animation, flash, usability, etc.).',
      link: '/custom-web-solution',
    },
    {
      id: 8,
      icon: 'assets/images/advertising.svg',
      title: 'Social Media Marketing',
      description: 'If you’re lacking time, resources or a team to handle this domain, then we have got you covered! Leave it to us to generate quality leads to meet your audience goals!',
      link: '/social-media-marketing',
    },

  ]);



  return (
    <div className="boxes-container">
      {boxes.map((box) => (
        <div key={box.id} className="box" onClick={() => box.link && navigate(box.link)} style={{ cursor: 'pointer' }}>
          <div className="box-header">
            <img src={box.icon} alt={`${box.title} Icon`} />
            <h3>{box.title}</h3>
          </div>
          <p>{box.description}</p>
        </div>
      ))}
    </div>
  );
};


export default DynamicBoxes;
